import React from 'react';
import type { FC } from 'react';
import { styled } from '@material-ui/core';
import { Customer, Reservation } from '@/services/api/entities';
import SidebarEmptyResult from './SidebarEmptyResult';
import SidebarSearchData from './SidebarSearchData';

interface Props {
  readonly customers: Customer[];
  readonly reservations: Reservation[];
  readonly hasData: boolean;
}

const StyledNoInput = styled('span')({
  fontSize: '16px'
});

const SidebarSearchResult : FC<Props> = ({ hasData, customers, reservations }) => {
  if (hasData) {
    if (customers.length === 0 && reservations.length === 0) {
      return <SidebarEmptyResult />;
    } else {
      return (
        <SidebarSearchData
          customers={customers}
          reservations={reservations}
        />
      );
    }
  } else {
    return (
      <StyledNoInput>
        Enter guest's name, email, phone number or reservation confirmation
      </StyledNoInput>
    );
  }
};

export default SidebarSearchResult;
